import makeUseCellFilterAction, {
  UseCellFilterActionProps,
} from "ds/components/Table/helpers/makeUseCellFilterAction";
import { INTENT_PROJECT_RESOURCES_OPERATIONS_SUGGESTIONS_DICTIONARY } from "shared/IntentProject/useSearchIntentResourcesOperationsSuggestions/constants";

const useCellFilterAction = (props: UseCellFilterActionProps) => {
  return makeUseCellFilterAction({
    searchSuggestionsDictionary: INTENT_PROJECT_RESOURCES_OPERATIONS_SUGGESTIONS_DICTIONARY,
  })(props);
};

export default useCellFilterAction;
